import { TransitionLink } from '@/components/shared/TransitionLink';
import Image from 'next/image';
import React from 'react';

const Logo = ({ classNameForText }: { classNameForText?: string }) => {
  return (
    <TransitionLink href='/'>
      <section className=' flex justify-center items-center gap-3'>
        <div className=' relative'>
          <Image
            src="/assets/logo/only-globe-white.svg"
            alt="Center logo"
            width={50}
            height={50}
            className={`object-cover rounded-full transition-all duration-300 animate-spin-slow`}
          />

          <Image
            src="/assets/logo/bw.svg"
            alt="bw"
            width={50}
            height={50}
            className=" absolute top-[1px] left-[1px]"
          />
        </div>

        <p className={`font-semibold text-xl ${classNameForText}`}>{'Build Web IT'.toUpperCase()}</p>

        {/* <div>
        <Image
          src="/images/logo/buildwebit.png"
          alt="buildwebit"
          width={130}
          height={130}
          className=""
        />
      </div> */}
      </section>
    </TransitionLink>
  );
};

export default Logo;
